var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeXmark = function SvgVolumeXmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.799 14.703-.341-.303H2.4V9.6h4.058l.34-.304 5.06-4.496H12v14.4h-.142zM1.2 15.6H6l5.4 4.8h1.8V3.6h-1.8L6 8.4H1.2v7.2m15.424-.177 2.576-2.576 2.576 2.576.848-.847L20.048 12l2.576-2.577-.848-.847-2.576 2.576-2.576-2.576-.848.847L18.353 12l-2.577 2.576z"
  })));
};
export default SvgVolumeXmark;